import React, { useEffect } from 'react';
import { Button, Card, Table, Space, Popconfirm, Typography } from 'antd';
import { PlusOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { usePayroll } from '../../hooks/usePayroll';
import PayrollStatusBadge from '../../components/PayrollStatusBadge';
import { PayrollPeriod } from '../../types';

const { Title } = Typography;

const PayrollDashboardView: React.FC = () => {
  const navigate = useNavigate();
  const { periods, isLoading, fetchPeriods, cancelPayroll } = usePayroll();

  useEffect(() => { fetchPeriods(); }, []);

  const columns = [
    { title: 'Period Code', dataIndex: 'periodCode', key: 'periodCode', width: 130 },
    { title: 'Period Name', dataIndex: 'periodName', key: 'periodName' },
    { title: 'Start', dataIndex: 'startDate', key: 'startDate', width: 110 },
    { title: 'End', dataIndex: 'endDate', key: 'endDate', width: 110 },
    { title: 'Pay Date', dataIndex: 'payDate', key: 'payDate', width: 110 },
    { title: 'Frequency', dataIndex: 'paymentFrequency', key: 'paymentFrequency', width: 100 },
    { title: 'Employees', key: 'employees', width: 110, render: (_: any, r: PayrollPeriod) => `${r.processedEmployees}/${r.totalEmployees}` },
    {
      title: 'Status', dataIndex: 'status', key: 'status', width: 140,
      render: (s: any) => <PayrollStatusBadge status={s} />,
    },
    {
      title: 'Actions', key: 'actions', width: 160,
      render: (_: any, record: PayrollPeriod) => (
        <Space size="small">
          <Button icon={<EyeOutlined />} size="small" onClick={() => navigate(`/hr/payroll/${record.id}`)}>
            View
          </Button>
          {(record.status === 'DRAFT' || record.status === 'PENDING_APPROVAL') && (
            <Popconfirm title="Cancel this payroll?" onConfirm={() => cancelPayroll(record.id)}>
              <Button size="small" danger>Cancel</Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div className="p-6">
      <div className="flex-between mb-4">
        <Title level={3} style={{ margin: 0 }}>Payroll</Title>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/hr/payroll/new')}>
          New Payroll Run
        </Button>
      </div>
      <Card>
        <Table dataSource={periods} columns={columns} rowKey="id" loading={isLoading} size="small" />
      </Card>
    </div>
  );
};

export default PayrollDashboardView;
